/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { Tooltip, useModal } from '@jutro/components';
import appConfig from 'app-config';
import { MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Rewrite } from 'ml-capability-rewrite-react';
import { MLTagManagerService } from 'ml-portals-services-react'
import { Reinstatement } from 'ml-capability-reinstatement-react';
import { UserService } from 'gw-capability-gateway';
import MLBundleManager from '../MLBundleManager/MLBundleManager';
import paWizardConfig from '../../../gw-capability-policychange-pa-react/config/pa-policychange-wizard-config.json5';
import hoWizardConfig from '../../../gw-capability-policychange-ho-react/config/ho-wizard-config.json5';
import pupWizardConfig from '../../../gw-capability-policychange-pup-react/config/pup-wizard-config.json5';
import ampPaWizardConfig from '../../../gw-capability-policychange-pa-react/config/pa-amp-wizard-config.json5';
import ampHoWizardConfig from '../../../gw-capability-policychange-ho-react/config/ho-amp-wizard-config.json5';
import ampPupWizardConfig from '../../../gw-capability-policychange-pup-react/config/pup-amp-wizard-config.json5';
import messages from './MLChangePolicyBtnComponent.messages';
import styles from './MLChangePolicyBtnComponent.module.scss';

import { Button } from '@jutro/legacy/components';

import { Link } from '@jutro/router';

function MLChangePolicyBtnComponent(props) {
    const modalApi = useModal();
    const {
        policyNumber,
        productCode,
        canChange,
        canCancel,
        canAccessGroup,
        isFutureCancellation,
        canReinstate,
        canRewrite,
        changeSteps,
        canManageBundle,
        canExcludeDrivers,
        allPolicies,
        label,
        singleStep,
        isAkSevenDayAutoPolicy,
        history,
        jumpToInProgressStep,
        buttonClassName,
        earliestCancellationDate,
        policyTermEffectiveDate,
        policyTermExpirationDate,
        coveragePartType,
        hideMakeChangesButton,
        isModernProduct,
        isSummaryPage,
        policyInformation,
        baseState
    } = props;

    const isPersonalAuto = productCode === 'PersonalAuto';
    const isHomeowners = productCode === 'HOPHomeowners' || productCode === 'Homeowners';
    const translator = useTranslator();
    const ampMode = appConfig.portalCode === 'AMP';
    const { authHeader } = useAuthentication();

    const [makeChangesMenuList, setMakeChangesMenuList] = useState([]);
    const [user, setUser] = useState([])

    useEffect(() => {
        UserService.getCurrentUser(authHeader).then((currentUser) => {
        setUser(currentUser);
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const createMenuListObj = (bundle, path, _label, action, global) => {
        return {
            action,
            bundle,
            label: _label,
            path,
            global
        };
    };
    const sendTagManagerEvent = (_label) => {
        const change = _label ? `Make Changes_${_label}` : 'UpdatePaymentOption';
        const formName = MLTagManagerService.getFormName() === MLTagManagerService.getStepName() ?
            `${MLTagManagerService.getStepName()}_${change}` :
            `${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_${change}`;
        MLTagManagerService.sendFormStartEvent(formName);
    };

    const sendPolicyChangeEvent = (item) => {
        MLTagManagerService.sendLinkClickEvent(`PolicyChange_${item}`);
    };

    const startPolicyChange = useCallback((chosenStepPathML, _label) => {
        // Set start time for page load performance tracking
        sessionStorage.setItem('userSubmitAction', true);
        sessionStorage.setItem('userSubmitted', new Date());
        sendTagManagerEvent(_label);
        MLNavigationStepsTrackingService.init('PolicyChange', productCode, translator);
        const { lobEndorsementURL, endorsementProducts } = appConfig;
        if (endorsementProducts.includes(productCode)) {
            history.push(lobEndorsementURL[productCode], { policyNumber, chosenStepPathML });
        }
    }, [history, policyNumber, productCode, translator]);

    const createManageBundle = useCallback(() => {
        modalApi.showModal(
            <MLBundleManager policies={allPolicies} />
        );
    }, [allPolicies]);

    const cancelPolicy = useCallback((_label) => {
        sendTagManagerEvent(_label);
        const cancellationData = {
            policy: {
                policyNumber: policyNumber,
                earliestCancellationDate: earliestCancellationDate,
                policyTermEffectiveDate: policyTermEffectiveDate,
                policyTermExpirationDate: policyTermExpirationDate,
                isCancellationRestrictedML: policyInformation?.isCancellationRestrictedML_Ext ?? false
            },
            baseState,
            cancellationSource: 'insured'
        };
        history.push('/cancellation-flow', { cancellationData });
    }, [earliestCancellationDate, history, policyNumber, policyInformation]);

    const reinstatePolicy = useCallback(() => {
        // Start reinstate Policy Flow - do as part of reinstate story
        const reinstatementData = new Reinstatement({
            policyNumber
        });
        history.push('/reinstatement-flow', { reinstatementData });
    }, [history, policyNumber]);

    const rewritePolicy = useCallback(() => {
        // Start rewrite Policy Flow - do as part of rewrite story
        const rewriteData = new Rewrite({
            policy: {
                policyNumber: policyNumber
            }
        })
        history.push('/rewrite-flow', { rewriteData });
    }, []);

    const updateDynamicStartingPoint = useCallback((step) => {
        if (isHomeowners && step.mlStepName === 'endorsementHoPropertyDetails') {
            if (coveragePartType !== 'hoprental') {
                step.stepProps.isStartingPointML = true;
            } else {
                step.stepProps.isStartingPointML = false;
            }
        }
    }, [coveragePartType, isHomeowners]);

    const availablePolicyChangeSteps = useCallback((steps) => {
        return steps.filter((step) => {
            updateDynamicStartingPoint(step);

            if (_.get(step, 'stepProps.isStartingPointML', false)) {
                if ((step.mlStepName === 'endorsementPaListHouseholdMembers' || step.mlStepName === 'endorsementPupListNonDrivingVehicleOperators') && isModernProduct) {
                    step.label = translator(messages.NonDrivers);
                } else {
                    step.label = step.stepProps.stepButtonLabelML ? translator(step.stepProps.stepButtonLabelML) : translator(step.title);
                }
                return true;
            }
            return false;
        });
    }, [translator, updateDynamicStartingPoint]);

    const verifyExclusionSteps = useCallback((wizard, targetStep) => {
        const index = wizard.steps.findIndex((step) => step.id === targetStep);
        wizard.steps[index].stepProps.isStartingPointML = canExcludeDrivers && canExcludeDrivers();
    }, [canExcludeDrivers]);

    const initPolicyChangeStartableSteps = useCallback(() => {
        let wizardConfig;
        if (ampMode) {
            if (isPersonalAuto) {
                verifyExclusionSteps(ampPaWizardConfig, 'endorsementPaListExcludedDrivers')
                wizardConfig = ampPaWizardConfig;
            } else if (isHomeowners) {
                wizardConfig = ampHoWizardConfig;
            } else {
                verifyExclusionSteps(ampPupWizardConfig, 'endorsementPupListExcludedVehicleOperators')
                wizardConfig = ampPupWizardConfig;
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (isPersonalAuto) {
                verifyExclusionSteps(paWizardConfig, 'endorsementPaListExcludedDrivers')
                wizardConfig = paWizardConfig;
            } else if (isHomeowners) {
                wizardConfig = hoWizardConfig;
            } else {
                verifyExclusionSteps(pupWizardConfig, 'endorsementPupListExcludedVehicleOperators')
                wizardConfig = pupWizardConfig;
            }
        }

        const { steps } = wizardConfig;
        return availablePolicyChangeSteps(steps);
    }, [ampMode, availablePolicyChangeSteps, isHomeowners, isPersonalAuto, verifyExclusionSteps]);

    const addRentedTrailerStepIfMissing = useCallback(
        (isSummaryPage, changeStep = [], startableSteps = []) => {
            if (!isSummaryPage) return changeStep;

            const RENTED_TRAILER_STEP_ID = 'endorsementPaListRentedTrailerCamper';

            if (changeStep.some(step => step?.id === RENTED_TRAILER_STEP_ID)) {
                return changeStep;
            }

            const rentedTrailerStep = startableSteps.find(
                step => step?.id === RENTED_TRAILER_STEP_ID
            );

            if (!rentedTrailerStep) return changeStep;

            const minimalStep = {
                path: rentedTrailerStep.path,
                label: rentedTrailerStep.label
            };

            return [...changeStep, minimalStep];
        },
        []
    );

    const isGroupPolicy = policyInformation?.latestPeriod?.accountCodeGAF_ML;
    const paymentPlan = policyInformation?.billingDetails_ML?.paymentPlan_ML?.name;

    const initMakeChangesMenuList = useCallback((startableSteps) => {
        const newMenuList = [];
        if (!isFutureCancellation && !canChange) {
            startableSteps.forEach((step) => {
                const menuObj = createMenuListObj(false, step.path, translator(step.label), startPolicyChange, false);
                newMenuList.push(menuObj);
            });
            const canCancel = createMenuListObj(false, '', translator(messages.cancelPolicy), cancelPolicy, true);
            newMenuList.push(canCancel);
        } else {
            if (canChange) {
                startableSteps.forEach((step) => {
                    if (step.mlStepName === 'endorsementPaListRentedTrailerCamper' && !isModernProduct) return;
                    if (canAccessGroup || (step.mlStepName !== 'endorsementPaGroupAssociations' && step.mlStepName !== 'endorsementHoGroupAssociations' &&
                        step.mlStepName !== 'endorsementPupGroupAssociations')) {
                        const menuObj = createMenuListObj(false, step.path, translator(step.label), startPolicyChange, false);
                        newMenuList.push(menuObj);
                    }
                });
            } else if (changeSteps) {
                const updatedChangeStep = addRentedTrailerStepIfMissing(
                    isSummaryPage,
                    changeSteps,
                    startableSteps
                );
                updatedChangeStep.forEach((step) => {
                    const menuObj = createMenuListObj(false, step.path, translator(step.label), jumpToInProgressStep, false);
                    if (canAccessGroup === true || step.path !== '/affiliation') {
                        newMenuList.push(menuObj);
                    }
                });
            }
            if (canCancel) {
                const menuObj = createMenuListObj(false, '', translator(messages.cancelPolicy), cancelPolicy, true);
                newMenuList.push(menuObj);
            }
            if (canReinstate) {
                const menuObj = createMenuListObj(false, '', translator(messages.reinstatePolicy), reinstatePolicy, true);
                newMenuList.push(menuObj);
            }
            if (canRewrite) {
                const menuObj = createMenuListObj(false, '', translator(messages.rewritePolicy), rewritePolicy, true);
                newMenuList.push(menuObj);
            }
            if (canManageBundle && canChange && allPolicies.length > 1) {
                const menuObj = createMenuListObj(true, '', translator(messages.createManageBundle), createManageBundle, true);
                newMenuList.push(menuObj);
            }
        }

    const updatedMenuList = _.sortBy(newMenuList, 'label');

    if ( !_.isNil(isGroupPolicy) ) {
        if( paymentPlan === "Payroll Deduction" || (isModernProduct && !_.isUndefined(coveragePartType) && (coveragePartType === 'hop_landlord_condo_ml' || coveragePartType === 'hop_landlord_home_ml'))) {
            setMakeChangesMenuList(updatedMenuList.filter(item => item.path !== "/transfer-to-payroll"));
        }
        else {
        setMakeChangesMenuList(updatedMenuList);
        }
        }
    else {
        setMakeChangesMenuList(updatedMenuList.filter(item => item.path !== "/transfer-to-payroll"));
    }

    }, [isFutureCancellation, canChange, isGroupPolicy, translator, cancelPolicy, startPolicyChange, changeSteps, canCancel, canReinstate, canRewrite, canManageBundle, allPolicies.length, isModernProduct, canAccessGroup, addRentedTrailerStepIfMissing, isSummaryPage, jumpToInProgressStep, reinstatePolicy, rewritePolicy, createManageBundle, paymentPlan]);

    useEffect(() => {
        const policyChangeStartableSteps = initPolicyChangeStartableSteps();
        initMakeChangesMenuList(policyChangeStartableSteps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canAccessGroup]);

    const getMenuContent = () => {
        return !_.isEmpty(makeChangesMenuList) && (
            <ul className={cx(styles.menuChangesList, 'styled-ul-list')}>
                {makeChangesMenuList.map((step) => {
                    return (
                        <li>
                            <a onClick={(e) => {
                                e.preventDefault();
                                step.action(step.path, step.label)
                            }} className={cx(styles.changesButton)}>
                                {step.label}
                            </a>
                        </li>
                    );
                })}
            </ul>
        );
    };


    const getGpaMultipleStepsButton = () => {
        return (
            <Tooltip
                id="gpaMakeChangesTooltip"
                placement="bottom"
                trigger="click"
                content={getMenuContent()}
            >
                <Button type="filled" className={`${buttonClassName}`}>
                    {label || translator(messages.makeChanges)}
                    <i className="ml-btn-icon icon-ml-carrot-down-outline margin-left-5" />
                </Button>
            </Tooltip>
        );
    };

    const getAmpLink = () => {
        const onClick = (e) => {
            e.stopPropagation();
            sendPolicyChangeEvent('dropdown selected')
        }
        return (
            <Tooltip
                id="ampLinkTooltip"
                placement="bottom"
                trigger="click"
                content={getMenuContent()}
            >
                <Button type="outlined" onClick={onClick}>
                    {label || translator(messages.changeMyPolicy)}
                    <i className="ml-btn-icon margin-left-5" />
                </Button>
            </Tooltip>
        );
    };

    const getSingleStepBtn = () => {
        return (
            label ? (
                <Button type="outlined" className={buttonClassName} onClick={() => startPolicyChange(singleStep)}>{label}</Button>
            ) : (
                <Button type="outlined" className={buttonClassName} onClick={() => startPolicyChange(singleStep)}>
                    {translator(messages.makeChanges)}
                    <i className="ml-btn-icon icon-ml-carrot-down-outline margin-left-5" />
                </Button>
            )
        )
    };

    if (!changeSteps && !singleStep && makeChangesMenuList.length > 0 && !ampMode && !hideMakeChangesButton) {
        return getGpaMultipleStepsButton();
    }
    if (!changeSteps && !singleStep && makeChangesMenuList.length > 0 && ampMode && !isAkSevenDayAutoPolicy) {
        return getAmpLink();
    }
    if (changeSteps && makeChangesMenuList.length > 0 && !hideMakeChangesButton) {
        return getGpaMultipleStepsButton();
    }
    if (singleStep) {
        return getSingleStepBtn();
    }
    return null;
}


MLChangePolicyBtnComponent.propTypes = {
    policyNumber: PropTypes.string,
    productCode: PropTypes.string,
    canChange: PropTypes.bool,
    canCancel: PropTypes.bool,
    canAccessGroup: PropTypes.bool,
    isFutureCancellation: PropTypes.bool,
    earliestCancellationDate: PropTypes.shape({}),
    policyTermEffectiveDate: PropTypes.shape({}),
    policyTermExpirationDate: PropTypes.shape({}),
    canRewrite: PropTypes.bool,
    canReinstate: PropTypes.bool,
    allPolicies: PropTypes.array,
    canManageBundle: PropTypes.bool,
    canExcludeDrivers: PropTypes.func,
    coveragePartType: PropTypes.string,
    changeSteps: PropTypes.array,
    singleStep: PropTypes.shape({}),
    label: PropTypes.string,
    isAkSevenDayAutoPolicy: PropTypes.bool,
    history: PropTypes.shape({}),
    buttonClassName: PropTypes.string,
    hideMakeChangesButton: PropTypes.bool,
    isModernProduct: PropTypes.bool,
    isSummaryPage: PropTypes.bool
};

MLChangePolicyBtnComponent.defaultProps = {
    allPolicies: [],
    buttonClassName: '',
    isFutureCancellation: true,
    isModernProduct: false,
    isSummaryPage: false
};

export default MLChangePolicyBtnComponent;
